module.exports = __webpack_public_path__ + "static/media/content-icon.0522af20.svg";